/**
 * Claro / AUTO / oscuro. Tres estados explícitos: un toggle de dos deja al
 * usuario sin poder decir "haz lo que haga mi móvil", que es lo que quiere
 * casi todo el mundo.
 */
import { useThemeStore, ThemeMode } from '../../store/useThemeStore';
import { Icon } from './Icon';

const MODES: { mode: ThemeMode; label: string }[] = [
  { mode: 'light', label: 'Tema claro' },
  { mode: 'auto', label: 'Tema automático' },
  { mode: 'dark', label: 'Tema oscuro' },
];

export function ThemeToggle() {
  const { mode, setMode } = useThemeStore();

  return (
    <div
      role="group"
      aria-label="Tema"
      className="flex gap-0.5 p-0.5 rounded-full bg-surface-2 border border-line"
    >
      {MODES.map((m) => {
        const active = mode === m.mode;
        return (
          <button
            key={m.mode}
            onClick={() => setMode(m.mode)}
            aria-label={m.label}
            aria-pressed={active}
            className={`h-7 rounded-full grid place-items-center transition-colors ${
              m.mode === 'auto' ? 'px-2 font-mono text-[10px] font-semibold' : 'w-8'
            } ${active ? 'bg-ink text-canvas' : 'text-ink-2'}`}
          >
            {m.mode === 'auto' ? 'AUTO' : <Icon name={m.mode === 'light' ? 'sun' : 'moon'} size={14} strokeWidth={2} />}
          </button>
        );
      })}
    </div>
  );
}
